import React, { FunctionComponent } from 'react';
import { MDXProvider } from '@mdx-js/react';
import customComponents from '../constants/customComponents';
import aliasComponents from '../constants/aliasComponents';

const components = {
  ...customComponents,
  ...aliasComponents(),
};

const MarkdownComponentsProvider: FunctionComponent<React.PropsWithChildren> = ({ children }) => (
  <MDXProvider components={components}>{children}</MDXProvider>
);

export default MarkdownComponentsProvider;
